(function(){
  var form=document.getElementById('PPV17ContactForm');
  if(!form) return;

  var submit=form.querySelector('[data-pp-support-submit]');
  var success=form.querySelector('[data-pp-support-success]');
  var errors=form.querySelector('[data-pp-support-errors]');

  // Use Shopify's native contact-form submission for reliability.
  // After Shopify reloads the page with a success/error state, reopen this modal.
  if(success || errors){
    if(window.location.hash !== '#pp-support'){
      window.location.hash='pp-support';
    }
  }

  if(submit){
    form.addEventListener('submit', function(){
      submit.disabled=true;
      var label=submit.querySelector('span');
      if(label) label.textContent='Sending…';
    });
  }
})();
